import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { InProductTrialsOverlayWindowsAppController } from '../controller/InProductTrialsOverlayWindowsAppController';
import { MenuState } from '../types/MenuState';

export class InProductTrialsOverlayWindowsAppWebComponent extends BaseWebComponentElement {
  public controller!: InProductTrialsOverlayWindowsAppController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InProductTrialsOverlayWindowsAppController,
    });
  }

  public setMenuState(menuState: MenuState) {
    this.controller.view.setMenuState(menuState);
  }

  public onMenuScrollEvent() {
    this.controller.view.onMenuScrollEvent();
  }

  public createInProductTrialsOverlayWindows() {
    this.controller.view.createInProductTrialsOverlayWindows();
  }

  public hideInProductTrialsOverlayWindowNewSectionIfAvailable(): boolean {
    return this.controller.view.hideInProductTrialsOverlayWindowNewSectionIfAvailable();
  }
}
